/** Basename for admin SPA (`/` on admin host, `/admin` when embedded in legacy bundle). */
export const ADMIN_BASENAME =
  (import.meta.env.VITE_ADMIN_BASENAME as string | undefined)?.replace(/\/$/, "") || "/";

export function adminPath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!ADMIN_BASENAME || ADMIN_BASENAME === "/") return normalized;
  return `${ADMIN_BASENAME}${normalized}`;
}
